// Diego, 13-oct (junta, segunda tanda): «ponle una LUPA con zoom al recibo cargado, no se alcanzan a ver los números».
// El PDF ya no va en un <iframe> (en el iPhone solo enseñaba la primera hoja y sin zoom): se dibuja cada hoja a imagen
// con pdf.js, a buena resolución, para hacerle zoom igual que a una foto. pdf.js se carga SOLO al abrir un PDF (import
// dinámico): no pesa en la carga de la app.

/** Ancho al que se dibuja cada hoja (px). Un recibo CFE carta a 2,400 px deja leer los números chicos a 4–6× en el celular. */
const ANCHO_HOJA_PX = 2400;
/** Tope de hojas que se dibujan (un recibo trae 1–4; un PDF raro de 100 hojas no debe colgar el teléfono). */
const MAX_HOJAS = 12;

export interface HojaDibujada {
  url: string;
  ancho: number;
  alto: number;
}

/** Dibuja las hojas del PDF a imágenes (URL blob). Quien llama libera las URL con URL.revokeObjectURL. */
export async function pdfAImagenes(url: string, aviso: { cancelado: boolean }): Promise<HojaDibujada[]> {
  const pdfjs = await import('pdfjs-dist');
  const trabajador = (await import('pdfjs-dist/build/pdf.worker.min.mjs?url')).default;
  if (!pdfjs.GlobalWorkerOptions.workerSrc) pdfjs.GlobalWorkerOptions.workerSrc = trabajador;
  const respuesta = await fetch(url, { credentials: 'same-origin' });
  if (!respuesta.ok) throw new Error(`No se pudo bajar el PDF (${respuesta.status}).`);
  const datos = new Uint8Array(await respuesta.arrayBuffer());
  const carga = pdfjs.getDocument({ data: datos });
  const doc = await carga.promise;
  const hojas: HojaDibujada[] = [];
  try {
    for (let n = 1; n <= Math.min(doc.numPages, MAX_HOJAS); n++) {
      if (aviso.cancelado) break;
      const hoja = await doc.getPage(n);
      const base = hoja.getViewport({ scale: 1 });
      const vista = hoja.getViewport({ scale: ANCHO_HOJA_PX / base.width });
      const lienzo = document.createElement('canvas');
      lienzo.width = Math.round(vista.width);
      lienzo.height = Math.round(vista.height);
      await hoja.render({ canvas: lienzo, viewport: vista }).promise;
      const blob = await new Promise<Blob | null>((r) => lienzo.toBlob(r, 'image/png'));
      lienzo.width = 0;
      lienzo.height = 0;
      if (!blob) throw new Error('El navegador no pudo dibujar la hoja del PDF.');
      hojas.push({ url: URL.createObjectURL(blob), ancho: Math.round(vista.width), alto: Math.round(vista.height) });
    }
  } finally {
    void carga.destroy();
  }
  return hojas;
}
